import { ResourceOptions } from 'react-admin';
import { MdOutlineChecklist } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';
export { OPERATIONS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultOperations;
export const icon = MdOutlineChecklist;
export const options: ResourceOptions = {
  label: 'module.vaultOperations.title',
};
